<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>入金予定明細</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div
            class="table-responsive tw-flex tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <table mat-table [dataSource]="dataSource" style="min-width: 685px;">
                <ng-container matColumnDef="kouzaRcvmnyFclt">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 150px;">口座入金機関
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.kouzaRcvmnyFclt }}</td>
                </ng-container>

                <ng-container matColumnDef="incYmd">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 75px;">取込日</th>
                    <td mat-cell *matCellDef="let row">{{ row.incYmd | dateString }}</td>
                </ng-container>

                <ng-container matColumnDef="rcvmnyNumber">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 90px;">入金件数
                    </th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.rcvmnyNumber | number}}</td>
                </ng-container>

                <ng-container matColumnDef="inshitaxwothFeeTargetcount">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 165px;">
                        (内)印紙税相当手数料対象件数</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.inshitaxwothFeeTargetcount |
                        number}}</td>
                </ng-container>

                <ng-container matColumnDef="receivemoneyyoteiMny">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 105px;">
                        入金予定額[円]</th>
                    <td mat-cell class="mat-cell-right" *matCellDef="let row">{{row.receivemoneyyoteiMny | number}}</td>
                </ng-container>

                <ng-container matColumnDef="energysystemCode">
                    <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width: 100px;">
                        エネシス</th>
                    <td mat-cell class="mat-cell-center" *matCellDef="let row">{{row.energysystemCode}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol;sticky:true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>